import React from 'react';
import CompetencyDetailScreen from '../../src/screens/progress/CompetencyDetailScreen';

export default function CompetencyDetailRoute() {
  return <CompetencyDetailScreen />;
}
